module.exports = __webpack_public_path__ + "assets/img/img37.174e53da.png";